import styled from '@emotion/styled';
import { breakpoints, spacing } from '@naf/theme';

export const TimelineImage = styled.div`
  width: 432px;
  flex: 0 0 auto;

  img {
    margin-top: ${spacing.space32};
    max-width: calc(100% - ${spacing.space48});
    height: auto;
    object-fit: cover;
  }

  p {
    line-height: 2.25rem;
    font-style: italic;
    margin-top: ${spacing.space24};
    margin-bottom: ${spacing.space24};

    @media (max-width: ${breakpoints.s}) {
      line-height: 2rem;
    }
  }

  &:first-child {
    margin-left: calc((100vw - 1120px) / 2);

    @media (max-width: ${breakpoints.xl}) {
      margin-left: ${spacing.space48};
    }

    @media (max-width: ${breakpoints.l}) {
      margin-left: ${spacing.space24};
    }
  }

  @media (max-width: ${breakpoints.m}) {
    width: 100vw;
    scroll-snap-align: start;

    img {
      max-width: calc(100vw - ${spacing.space48});
    }
  }
`;
